import { Injectable } from '@angular/core';
import { AnswerDraftCache } from '../ports/answer-draft-cache.port';
import { AnswerRow } from '../domain/types';

const KEY_PREFIX = 'data-extraction:answers:';

/** Best-effort localStorage-backed crash cache for answer drafts. */
@Injectable()
export class LocalStorageAnswerCache implements AnswerDraftCache {
  read(paperToProjectId: string): AnswerRow[] | null {
    try {
      const raw = localStorage.getItem(KEY_PREFIX + paperToProjectId);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? (parsed as AnswerRow[]) : null;
    } catch {
      return null;
    }
  }

  write(paperToProjectId: string, rows: AnswerRow[]): void {
    try {
      localStorage.setItem(KEY_PREFIX + paperToProjectId, JSON.stringify(rows));
    } catch {
      // Quota exceeded or private-mode: ignore; best-effort.
    }
  }

  clear(paperToProjectId: string): void {
    try {
      localStorage.removeItem(KEY_PREFIX + paperToProjectId);
    } catch {
      // ignore
    }
  }
}
